import PaymentsApi from '../../../../api/payments-api';
import { handleHttpInProgress } from '../../../shared/http-in-progress/actions/http-in-progress-actions';
import { toggleInfoModal, toggleDefaultErrorModal } from '../../../shared/info-modal/actions/info-modal-actions';
import constants from '../../../../common/constants';
import withdrawalActionTypes from '../constants/action-types';

export const requestWithdrawal = (amount, description, paymentMethodId, currency) => {
  return async dispatch => {
    dispatch(handleHttpInProgress(true));
    try {
      await PaymentsApi.requestWithdrawal(amount, description, paymentMethodId, currency);
      dispatch(handleHttpInProgress(false));
      dispatch(toggleInfoModal(true, constants.info_modal_types.success.value, 'WITHDRAWAL.SUCCESS_MESSAGE', null, null, '/app/payment-history'));
    } catch (error) {
      dispatch(handleHttpInProgress(false));
      dispatch(toggleDefaultErrorModal());
    }
  };
};

export const getRate = symbol => {
  return async dispatch => {
    dispatch(getRateInProgress(true));
    try {
      const response = await PaymentsApi.getRate(symbol);
      const rate = response && response.data && response.data.rate;
      dispatch(handleSuccessGetRate(rate));
      dispatch(getRateInProgress(false));
    } catch (error) {
      dispatch(getRateInProgress(false));
    }
  };
};

export const getRateInProgress = inProgress => {
  return {
    type: withdrawalActionTypes.GET_RATE_IN_PROGRESS,
    data: inProgress,
  };
};

export const handleSuccessGetRate = rate => {
  return {
    type: withdrawalActionTypes.HANDLE_SUCCESS_GET_RATE,
    data: rate,
  };
};



// WEBPACK FOOTER //
// ./src/app/main/withdrawals/actions/withdrawal-actions.js